import { tagsFilterAtom } from 'atoms/filters/rsim-products';
import { FilterAsyncChip } from 'common/components/FilterChip/FilterAsyncChip';
import { useAtom } from 'jotai';
import React from 'react';
import { useTagsContext } from 'tags/hooks/useTagsContext';

export const RSimTagsChips = () => {
  const { fetchTag, type: tagType } = useTagsContext();
  const [tags, setTags] = useAtom(tagsFilterAtom);

  const onClear = (id: string) => {
    setTags((currentTags) => currentTags.filter((tag) => tag !== id));
  };

  if (tags.length === 0) {
    return null;
  }

  return (
    <>
      {tags.map((tag) => {
        return (
          <React.Fragment key={tag}>
            <FilterAsyncChip
              labelPrefix="Tag"
              onCancel={() => {
                onClear(tag);
              }}
              fieldName="name"
              queryFn={() => {
                return fetchTag(tag);
              }}
              queryKey={['tag', tagType, tag]}
              queryEnabled={!!tag}
              variant="outlined"
            />
          </React.Fragment>
        );
      })}
    </>
  );
};
